import { useMemo } from "react"
import { getGramFromIngredients } from "model/food/utils/getPayloads/gram"
import { MealType } from "model/food/types"
import {
  isAIScanMeal,
  isEdamaMeal,
  isMyMeal,
} from "model/food/utils/typeGuards/mealTypeGuards"

export const getMealGram = (meal?: MealType) => {
  if (!meal) return 0

  // api food
  if (isEdamaMeal(meal)) {
    return meal.gram
  }

  // my food
  if (isMyMeal(meal)) {
    return getGramFromIngredients(meal.ingredients)
  }

  // not food yet
  if (isAIScanMeal(meal)) {
    return getGramFromIngredients(meal.ingredients)
  } else {
    return meal.gram
  }
}

const useMealGram = (meal?: MealType) => {
  return useMemo(() => {
    return getMealGram(meal)
  }, [meal])
}

export default useMealGram
